
const returnSteps = [
  {
    step: 1,
    title: 'Initiate Your Return',
    description: 'Contact our customer care team via email at returns@daliahsecret.com or through the contact form. Include your order number and reason for return.',
  },
  {
    step: 2,
    title: 'Receive Return Label',
    description: 'We&apos;ll send you a prepaid return shipping label within 24 hours. Simply print it and attach it to your package.',
  },
  {
    step: 3,
    title: 'Pack & Ship',
    description: 'Place items in their original packaging with all tags attached. Drop off at any authorized shipping location.',
  },
  {
    step: 4,
    title: 'Refund Processed',
    description: 'Once we receive and inspect your return, your refund will be processed within 3–5 business days to your original payment method.',
  },
];

const conditions = [
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Unused & Unopened',
    text: 'Products must be in their original, sealed condition with no signs of use.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Tags Attached',
    text: 'All original tags, labels, and seals must remain intact and unbroken.',
  },
  {
    icon: 'ri-inbox-unarchive-line',
    title: 'Original Packaging',
    text: 'Items should be returned in the original Daliah Secret box and packaging materials.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Proof of Purchase',
    text: 'Include your order confirmation email or packing slip with the return.',
  },
];

export default function ReturnsPolicy() {
  return (
    <section id="returns" className="py-20 bg-[#FAFAFA]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#2E7D32] text-sm tracking-[0.2em] mb-3 font-medium">HASSLE-FREE</p>
          <h2 className="text-3xl font-serif text-gray-900 mb-4">Returns &amp; Exchanges</h2>
          <p className="text-gray-500 text-sm max-w-lg mx-auto leading-relaxed">
            We offer a <strong className="text-gray-700">30-day return window</strong> on all purchases. If you&apos;re not completely satisfied, we&apos;ll make it right.
          </p>
        </div>

        {/* 30-Day Timeline */}
        <div className="bg-white rounded-2xl border border-gray-100 p-10 mb-12 shadow-sm">
          <div className="flex items-center justify-between mb-8">
            <h3 className="text-lg font-semibold text-gray-900">30-Day Return Window</h3>
            <span className="px-4 py-1.5 bg-[#E8F5E9] text-[#2E7D32] text-xs font-medium rounded-full whitespace-nowrap">
              Full Refund Guaranteed
            </span>
          </div>
          <div className="relative">
            <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
              <div className="h-full w-full bg-gradient-to-r from-[#2E7D32] via-[#4CAF50] to-[#A5D6A7] rounded-full"></div>
            </div>
            <div className="flex justify-between mt-4">
              <div className="text-center">
                <div className="w-8 h-8 rounded-full bg-[#2E7D32] flex items-center justify-center mx-auto mb-2">
                  <i className="ri-shopping-bag-line text-white text-sm"></i>
                </div>
                <p className="text-xs font-medium text-gray-900">Day 1</p>
                <p className="text-[11px] text-gray-400">Order Received</p>
              </div>
              <div className="text-center">
                <div className="w-8 h-8 rounded-full bg-[#4CAF50] flex items-center justify-center mx-auto mb-2">
                  <i className="ri-exchange-line text-white text-sm"></i>
                </div>
                <p className="text-xs font-medium text-gray-900">Day 15</p>
                <p className="text-[11px] text-gray-400">Exchange Available</p>
              </div>
              <div className="text-center">
                <div className="w-8 h-8 rounded-full bg-[#A5D6A7] flex items-center justify-center mx-auto mb-2">
                  <i className="ri-time-line text-[#1B5E20] text-sm"></i>
                </div>
                <p className="text-xs font-medium text-gray-900">Day 30</p>
                <p className="text-[11px] text-gray-400">Last Day to Return</p>
              </div>
            </div>
          </div>
        </div>

        {/* Return Conditions */}
        <h3 className="text-lg font-semibold text-gray-900 mb-6">Return Conditions</h3>
        <div className="grid grid-cols-4 gap-5 mb-16">
          {conditions.map((item) => (
            <div key={item.title} className="bg-white rounded-xl border border-gray-100 p-6 text-center shadow-sm hover:shadow-md transition-shadow">
              <div className="w-12 h-12 rounded-full bg-[#E8F5E9] flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-xl text-[#2E7D32]`}></i>
              </div>
              <h4 className="text-sm font-semibold text-gray-900 mb-2">{item.title}</h4>
              <p className="text-xs text-gray-500 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>

        {/* Return Steps */}
        <h3 className="text-lg font-semibold text-gray-900 mb-8">How to Return</h3>
        <div className="grid grid-cols-4 gap-6">
          {returnSteps.map((item, index) => (
            <div key={item.step} className="relative">
              {index < returnSteps.length - 1 && (
                <div className="hidden lg:block absolute top-6 left-[calc(50%+24px)] right-[-calc(50%-24px)] w-[calc(100%-12px)] h-[1px] border-t-2 border-dashed border-[#A5D6A7]"></div>
              )}
              <div className="bg-white rounded-xl border border-gray-100 p-6 shadow-sm relative z-10">
                <div className="w-12 h-12 rounded-full bg-[#2E7D32] flex items-center justify-center mb-4">
                  <span className="text-white font-semibold text-sm">{item.step}</span>
                </div>
                <h4 className="text-sm font-semibold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
